<template>
  <div v-if="$store.getters.isLoggedIn"
       class="navbar-submenu"
  >
    <span
      v-if="notificationsCount === 0"
      class="badge badge-success count-badge"
      style="cursor: pointer"
      @click="showSubMenu = !showSubMenu"
    >
      <i class="far fa-bell"></i>
    </span>
    <span v-else
          class="badge badge-danger count-badge"
          style="cursor: pointer"
          @click="showSubMenu = !showSubMenu"
    >
      <i class="fas fa-bell"></i> {{ notificationsCount }}
    </span>
    <div v-if="showSubMenu"
         class="notifications-submenu"
    >
      <div
        v-for="(n, $index) in sortedNotifications"
        :key="$index"
        class="notification-card"
        :class="[{ 'notification-card__is-read': n.isRead, 'notification-card__not-read': !n.isRead }, `notification-card-type-${n.type}`]"
        @click="interact(n)"
      >
        <div class="notification-card-icon">
          <i v-if="n.type === 'info'"
             class="fas fa-info-circle notification-type-indicator"
          ></i>
          <i
            v-if="n.type === 'error'"
            class="fas fa-exclamation-circle notification-type-indicator notification-type-indicator__error"
          ></i>
          <i
            v-if="n.type === 'success'"
            class="fas fa-check-circle notification-type-indicator notification-type-indicator__success"
          ></i>
          <!--<img :src="n.icon"
               alt="icon"
          />-->
        </div>

        <div class="notification-card-title">
          <a href="#">{{ n.title }}</a>
        </div>
        <div class="notification-card-body">{{ n.body }}</div>
        <div class="notification-card-time-ago">
          <i v-if="!n.isRead"
             class="fas fa-bell"
          ></i>
          {{ n.recievedTime.fromNow() }}
        </div>
      </div>
      <div v-if="!desktopNotificationsEnabled"
           class="info-card"
      >
        Nemáte povolené desktopové notifikace
        <ActiveButton class="asd-btn-confirm"
                      :click="requestNotificationsPermission"
        >
          Povolit
        </ActiveButton>
      </div>
    </div>
  </div>
</template>

<script>
import { get, filter, map, orderBy } from 'lodash'
import EventBus from 'CORE/bus'
import moment from 'moment'
import ActiveButton from 'CORE/components/form/active-button'
import axios from 'axios'

// eslint-disable-next-line max-len
const DEFAULT_ICON =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAACXUlEQVR4nO2aPWsUURSGj0YLJRBBECyMWAh+JMEgNhGstEoR/RHaCUaUFBaChaYISFSwknTRKikElaQxVYKCKDaKX00gKgQlfieB+F43A7LrzJ3ZnfOeJZ4HnnrPc3YWdvdeEcdxHMdxHC6b4XX4ftUbsNV0IjI34UqVI6YTkfkgtQv4AtdbDqXJNngG3oUfpTY+cR7eg+fhdpNJS2YXvAN/SXp0mktwDO6mT10C6+AF+F2Kh1f7E16CLdSCBtgAb0nj4dWOw03EjroI71L4nJcdnzgBN9Jq6mBQ9OITh2g1BTkIl0V/AeE1DpGaCjEp+vGJk6Sm3HQKLz6xm1KWk6vCX8AwpSwnr4S/gLeUshzsFH58YjuhL8oJsVvAcUJflAGxW8AAoS9K+DPDagHXCH1RbovdAkYJfVHCjxSrBYwR+qLcF7sFPCD0RZkSuwU81M+L80jsFjBD6IvyXOwW8IzQF+W12C3gJaEvymexW8A8oS+TNrGLT2xTr8zgQMpQTLvUKzPoSxmKaZ96ZQZXUoZielm9MoOZlKGYTqtXprBFKsdX1gtYWp2FTn8dw2rZr9xaQzjGtvwCVG34f5B6dnhWIaJRz6kW/8V+KefUt2x/wA7F7j/sgO+MQ7OclcqdBBX2wDdNEBkzvEH7yo4/Cj81QVxeF2BvWfEn4WITRBU1nCKfLmsJjtMYe+GpgnaaTKrEYSn+GT5mMqkS4drcU8kf/0LW4K3RcIfom8Tjwze6HqMZ1TkC5yQ9PlyjXVOP/r8Iv93DLdLH8KtUnoon8CLcajiX4ziO4zj/Gb8BC5G6ebDIvyEAAAAASUVORK5CYII='

export default {
    name: 'Notifications',
    components: {
        ActiveButton,
    },
    data() {
        return {
            showSubMenu: false,
            notifications: [],
        }
    },
    computed: {
        notificationsCount() {
            return filter(this.notifications, n => !n.isRead).length
        },
        desktopNotificationsEnabled() {
            return Notification.permission === 'granted'
        },
        sortedNotifications() {
            return orderBy(this.notifications, ['createdAt'], ['desc'])
        },
    },
    async mounted() {
        try {
            const userId = get(this.$store.getters.currentUser, 'id')
            const notifications = get(await axios.get(`/api/v1/notification/${userId}`), 'data', [])
            this.notifications = map(wnotifications, n => {
                if (get(n, 'createdAt')) {
                    this.$set(n, 'recievedTime', moment(get(n, 'createdAt'), 'X'))
                } else {
                    this.$set(n, 'recievedTime', moment())
                }
                return n
            })
        } catch (e) {
            this.notifications = []
        }

        EventBus.$on('NOTIFICATION_RECIEVED', async content => {
            this.$set(content, 'isRead', false)
            this.$set(content, 'recievedTime', moment())

            const title = get(content, 'title', 'Upozornění')
            const body = get(content, 'body', '')
            const icon = get(content, 'icon', DEFAULT_ICON)
            const requireInteraction = get(content, 'requireInteraction', false)

            const notification = new Notification(title, {
                body,
                icon,
                requireInteraction,
            })

            this.notifications.push(content)

            notification.onclick = () => {
                this.interact(content)
            }
        })
    },
    methods: {
        async interact(notification) {
            this.$set(notification, 'isRead', true)
            const externalUrl = get(notification.onclick, 'externalUrl', null)
            const internalRedirect = get(notification.onclick, 'internalRedirect', null)
            if (externalUrl) {
                window.open(externalUrl, '_blank')
            }
            if (internalRedirect) {
                await this.$router.push(internalRedirect)
            }
            const userId = get(this.$store.getters.currentUser, 'id')
            await axios.get(`/workflow/notifications/${userId}/${notification.id}/mark-read`)
        },
        async requestNotificationsPermission() {
            await Notification.requestPermission()
        },
    },
}
</script>

<style scoped lang="scss">
.notifications-submenu {
    z-index: 999999999;
    background-color: white;
    position: fixed;
    top: 37px;
    right: 8px;
    border: 1px solid var(--color-secondary);
    border-radius: 5px;
    width: 600px;
    height: auto;
    max-height: 75vh;
    box-shadow: 0px 0px 4px 4px rgba(0, 0, 0, 0.3);
    overflow: auto;
}
.info-card {
    color: black;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    text-align: center;
}
.notification-card {
    display: grid;
    color: black;
    margin: 5px;
    padding: 5px;
    grid-template-columns: 70px auto 170px;
    grid-template-rows: 25px 45px;
    border-radius: 5px;
    grid-template-areas:
        'icon title time-ago'
        'icon body body';

    &__not-read {
        & > img {
            border: 2px solid var(--primary);
        }
        .notification-card-time-ago {
            color: var(--primary);
            font-weight: bold;
        }
    }
    &__is-read {
        & > img {
            border: 2px solid var(--color-secondary);
        }
    }
    &-icon {
        & > .notification-type-indicator {
            position: absolute;
            color: var(--color-secondary);
            left: 3px;
            font-size: 20px;
            top: 3px;
            background-color: white;
            border-radius: 50%;
            &__error {
                color: var(--danger);
            }
            &__success {
                color: var(--success);
            }
        }
        & > img {
            width: 64px;
            height: 64px;
            margin: 3px;
            border-radius: 100%;
            border: 1px solid rgba(0, 0, 0, 0.07);
        }
        grid-area: icon;
        position: absolute;
    }
    &-title {
        grid-area: title;
        font-weight: bold;
    }
    &-body {
        grid-area: body;
        overflow: hidden;
        font-size: 70%;
        white-space: pre-line;
    }
    &-time-ago {
        grid-area: time-ago;
        color: var(--color-primary);
        font-style: italic;
        text-align: right;
        font-size: 85%;
    }
    &-type-error {
        .notification-card-title {
            color: var(--danger);
        }
    }
    &-type-success {
        .notification-card-title {
            color: var(--success);
        }
    }
    &:hover {
        background-color: rgba(0, 0, 0, 0.07);
        cursor: pointer;
    }
    &:not(:last-child) {
        margin: 5px 5px 15px 5px;
    }
}
</style>
